import React, { useState } from 'react';
import { Box, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import useUserAuth from '../../../utils/useUserAuth';

import UserTransferTable from './UserTransferTable';
import TransferProductTable from './TransferProductTable';
import TransferModal from './TransferModal';
import { StyledTabs, TabsWrapper, SubSectionTitle } from './UserTransferStyled';

const TAB_TICKET = 'TICKET';
const TAB_PASS = 'PASS';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});

const UserTransfer = ({ user, bigUser }) => {
  const { t } = useTranslation();
  const canTransfer = useUserAuth('MEMBER_TRANSFER');
  const [selectedTab, setSelectedTab] = useState(TAB_TICKET);

  // 양도 모달: 양도 대상 상품(수강권/이용권)
  const [transferProduct, setTransferProduct] = useState(null);

  const handleChangeTab = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div>
      <Container>
        {/* 보유 수강권/이용권 양도 테이블 + 행별 [양도] 버튼 */}
        <TransferProductTable user={user} bigUser={bigUser} onTransferClick={setTransferProduct} disableTransfer={!canTransfer} />

        {/* 양도 신청 승인 내역 — CRM에서 불필요하여 숨김 (요청)
        <Box>
          <SubSectionTitle>{t('양도 신청 승인 내역')}</SubSectionTitle>
          <TabsWrapper>
            <StyledTabs
              value={selectedTab}
              onChange={handleChangeTab}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="user transfer tabs">
              <Tab value={TAB_TICKET} label={t('Ticket Transfer')} />
              <Tab value={TAB_PASS} label={t('Pass Transfer')} />
            </StyledTabs>
          </TabsWrapper>

          <UserTransferTable type={selectedTab} user={user} bigUser={bigUser} />
        </Box>
        */}
      </Container>

      <TransferModal
        open={!!transferProduct}
        onClose={() => setTransferProduct(null)}
        product={transferProduct}
        user={user}
        bigUser={bigUser}
      />
    </div>
  );
};

export default UserTransfer;
